import React from 'react';
import {
  FormControl,
  Grid, TextField,
  Button,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import * as yup from 'yup';
import { PopoverComponentRef } from '../Popover';

const validationSchema = yup.object().shape({
  feedback: yup.string().required('Feedback is required.'),
});

export type FeedbackFormValues = {
  feedback: string;
};

interface FeedbackFormProps extends PopoverComponentRef {
  onSubmit: (data: FeedbackFormValues, close?: () => void) => void;
}

const FeedbackForm = function FeedbackForm(props: FeedbackFormProps) {
  const { onSubmit, close } = props;
  const resolver = useYupValidationResolver(validationSchema);
  const methods = useForm<FeedbackFormValues>({
    resolver,
  });
  const {
    handleSubmit, control, reset,
  } = methods;

  const submitHandler = (data: FeedbackFormValues) => {
    onSubmit(data, close);
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <div className="p-4 pt-6">
        <Grid container direction="column" minWidth={400} spacing={2} p={2}>
          <Grid item md={12}>
            <Controller
              name="feedback"
              control={control}
              render={({ field, fieldState }) => (
                <FormControl variant="standard" className="relative flex-1 w-full">
                  <TextField autoFocus error={!!fieldState.error} rows={5} {...field} multiline placeholder="Enter feedback on your disagreement" />
                  {fieldState.error?.message && (
                    <span className="absolute -bottom-5 text-xs text-primary">
                      {fieldState.error?.message}
                    </span>
                  )}
                </FormControl>
              )}
            />
          </Grid>
          <Grid item md={12} gap={2} className="mt-2 flex justify-center">
            <Button
              type="submit"
              variant="contained"
              size="small"
            >
              Submit
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => reset({ feedback: undefined })}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </div>
    </form>
  );
};

FeedbackForm.defaultProps = {

};

FeedbackForm.propTypes = {

};

export default FeedbackForm;
